//EMPLOYEES
export const ADD_EDIT_EMPLOYEE = "6887031f3a0aa947941dbe67"
export const ADD_EDIT_EMPLOYEE_DESIGNATION="689b00ffa13feaf2307b4d83"
export const GENDER="688704db3a0aa947941e073f"
export const USER_TYPE="688706fc3a0aa947941e1d69"
export const EMPLOYEE_STATUS="6887075c3a0aa947941e1da1"
export const MARITAL_STATUS="688708753a0aa947941e1e8c"
export const BLOOD_GROUP="688708cf3a0aa947941e1eb6"
export const EMPLOYEE_DEPARTMENT="6887065f3a0aa947941e07fa"
export const EMPLOYEE_PROCESS_SPECIALIZATION= "689b0127a13feaf2307b4d87"
export const EMPLOYEE_BDE= "689b0863a13feaf2307c2594"
export const EMPLOYEE_TECHNICAL_SPECIALIZATION="689b0885a13feaf2307c2596"

//EMPLOYEES-BASIC INFO
export const BASIC_INFO="68871a6b3a0aa9479421403e"
export const EMPLOYMENT_TYPE =  "68871aae3a0aa94794215449"
export const WORK_TYPE = "68871b063a0aa94794216975"
export const SHIFT_TIMINGS="68871b5b3a0aa947942169d6"
export const PROBATION_STATUS="68871cea3a0aa94794217fe7"

//EMPLOYEES-EMPLOYEMENT STATUS INFO
export const EMPLOYEMENT_STATUS_INFO="6887204b3a0aa9479421d69d"
export const EMPLOYMENT_STATUS="6887206e3a0aa9479421ebd3"
export const RESIGNATION_STATUS="6887209c3a0aa9479421ecd5"
export const REHIRE_ELIGIBILITY="688720c73a0aa9479421fc7b"

//EMPLOYEES-WORK HISTORY
export const WORK_HISTORY="688721703a0aa947942243c3"
export const PROCESS_HANDLED="688724853a0aa94794231814"


//EMPLOYEES-TEAMS
export const DIRECT_REPORTS = "6887478e3a0aa94794285f29" 
export const TEAM_TYPE="688747ae3a0aa94794285f3b"

//EMPLOYEES-EDUCATION INFO
export const EDUCATION_INFO = "68874d233a0aa94794290244"
export const EDUCATION_LEVEL = "68874d3b3a0aa9479429024a"

//EMPLOYEES-FAMILY INFO
export const FAMILY_INFO = "688750d83a0aa947942981b4"
export const DEPENDENT = "688750f33a0aa947942981c2"

//ID-CARD
export const ID_CARD = "6887677a3a0aa947942b4691"
export const ROLE="688768c53a0aa947942b4873"
export const TEAM="688769633a0aa947942b48ca"

//GENERATE PAYSLIP
export const GENERATE_PAYSLIP = "689312f03b7e52b98e9163cb"
export const INPUT_TYPE = "6893134d3b7e52b98e9163e9"
export const PERCENTAGE_OF_OTHER_FIELD="689313c03b7e52b98e916414"

//SALES-ADD & EDIT-LEAD INFORMATION
export const LEAD_INFORMATION = "68885d313a0aa94794350dc6";
export const PRIORITY = "68885d553a0aa94794350f20";
export const LEAD_STATUS = "68885df53a0aa947943532de";
export const LEAD_STAGE = "68885e883a0aa9479435355a";
export const LEAD_CHANNEL = "68885f093a0aa94794354bea";

//SALES-ADD & EDIT-AGENCY INFORMATION
export const AGENCY_INFORMATION = "6888610a3a0aa9479435cd2b";
export const TIMEZONE = "688861373a0aa9479435e3db";

//SALES-ADD & EDIT-CALLING TRACK
export const CALLING_TRACK = "6888641f3a0aa94794363a86";
export const CALL_STATUS = "6888643a3a0aa94794363aad";

//SALES-ADD & EDIT-LINKEDIN TRACK
export const LINKEDIN_TRACK = "6888677b3a0aa9479436984c";
export const REQUEST_STATUS = "688867cc3a0aa94794369b7c";

//SALES-ADD & EDIT-SCHEDULING A CALL AND OPERATIONS TEAM
export const SCHEDULING_CALL = "688868ad3a0aa9479436a0f6";
export const TYPE_OF_CALL="688868cc3a0aa9479436b579"
export const OPERATIONS_TEAM = "688867ee3a0aa94794369c3c";

//REQUESTS-ADD REQUEST
export const ADD_REQUEST = "688866993a0aa947943695a7";
export const REQUEST_PRIORITY = "688866b53a0aa94794369600";

//REQUESTS-ADD & EDIT- REQUEST DETAILS
export const REQUEST_DETAILS = "68886b5f3a0aa9479436e54c";  
export const REQUEST_TYPE = "68886b7a3a0aa9479436e56e";
export const REQUEST_DEPARTMENT = "688887a63a0aa9479438daaa";
export const PERSONAL_LINE = "688887d43a0aa9479438dad9";

//REQUESTS- EDIT-REQUEST INFO & REQUEST FILTER
export const REQUEST_INFO = "688889f73a0aa9479439a3f1";
export const EDIT_REQUEST_PRIORITY = "68888a1b3a0aa9479439a4f2";
export const EDIT_REQUEST_STATUS = "68888cfd3a0aa947943a3ab4";
export const REQUEST_STAGE = "68888d943a0aa947943a3d23";

//REQUEST FILTER STAGE
export const REQUEST_FILTER= "68932ad63b7e52b98e931ced"
export const REQUEST_FILTER_STAGE="68932b293b7e52b98e933220"

//REQUESTS-EXISTING POLICY & NEW QUOTE INFO-PERSONAL LINE
export const EXISTING_POLICY_INFO = "68919c8c4701bdbe63ffa738";
export const REQUEST_PERSONAL_LINE = "6891dc924701bdbe6305542e";
export const CURRENT_CARRIER = "68919d084701bdbe63ffd49f";

//REQUESTS-NEW QUOTE INFO
export const NEW_QUOTE = "6891e55d4701bdbe63073b5c";
export const ELIGIBILITY = "68998fa53b7e52b98ec58e24";
export const INSURANCE_CARRIER = "6891ea264701bdbe63079bbf";

//REQUESTS-EXISTING POLICY & NEW QUOTE--COMMERCIAL LINE
export const COMMERCIAL_POLICY_INFO = "6899a5053b7e52b98ec6bfc9";
export const COMMERCIAL_LINE = "6899a56d3b7e52b98ec6c089";

//OPERATION RECORDS
export const RECORDS="68888a393a0aa9479439a54a"
export const TASKS="68888f983a0aa947943a6b90" //FOR BOTH OPERATION AND SALES RECORDS
export const SLA_MISSED="688893753a0aa947943ae801"

//SALES RECORDS
export const SALES_RECORDS="68889f4f3a0aa947943b5848";
export const PRODUCTIVE_TYPE="6888a3bd3a0aa947943ba144";
//Asset
export const ADD_ASSET = "68997c0a3b7e52b98ec2d6ef"
export const ASSET_CATEGORY = "68997c3f3b7e52b98ec2d957"
//Holidays
export const ADD_HOLIDAY = "6887629a3a0aa947942aefcd"
//Clients
export const ADD_CLIENT = "68883e2f3a0aa94794326e82"
//Employee client info service same in clients
export const CLIENT_INFO = "688730903a0aa9479423e474"

export const ADD_CLIENT_TIMEZONE = "68883e843a0aa94794327dc3"
export const ADD_CLIENT_DEPARTMENT = "68883ed13a0aa94794327e0b"
export const CLIENT_SERVICESASSIGNED = "6887315c3a0aa9479423eb36"
export const CLIENT_STATUS = "68884ab13a0aa94794338bd1"

//leave settings
export const LEAVE_SETTINGS = "6887657d3a0aa947942b3559";
export const LEAVEETTINGS_YEAR =  "688765e03a0aa947942b37bc"

//Bulkemails campaign
export const  CAMPAIGNS = "688aeed33a0aa947944aef1e"
export const  FILTER_BY_STATUS = "688aef023a0aa947944aef80"

//user issues
export const USER_ISSUES = "688c37583a0aa94794585727"
export const ISSUE_STATUS = "688c37823a0aa9479458575a"
export const TECH_STACK="691e93f6b919ea11118ea1bc"

// Employee leaves 
export const EMPLOYEE_LEAVES = "68875c7b3a0aa947942a066e"
export const LEAVE_TYPE = "68875cb63a0aa947942a075b"

//Admin leaves leave type is same in both employee and admin leaves
export const ADMIN_LEAVES = "6887669f3a0aa947942b387f"
export const  LEAVE_STATUS = "688766f63a0aa947942b38e8"

//Finance
export const FINANCE = "688af1113a0aa947944b2a69"
export const FINANCE_CATEGORYS = "688af14d3a0aa947944b2acc"
export const FINANCE_MODE_OF_PAYMENT = "688b013c3a0aa947944cccb3"

// dynamic routes
export const DYNAMIC_ROUTES = "688aea853a0aa947944a2691"
export const DYNAMIC_ROUTES_ROLE = "688aebd23a0aa947944a44ce"

//Reports Employee reports and client reports are same in both.
export const REPORTS = "688ae8e33a0aa9479449dbaa"
export const REPORTS_BILLABLE = "688ae9153a0aa9479449de5d"

//request timer and sales time task is same
export const REQUEST = "688c3f613a0aa94794591a3d"
export const REQUEST_SERVICES_TIMER = "688c3f963a0aa94794591a91"
export const REQUEST_TASK_TIMER = "6891a29e4701bdbe63002b32"

// Header Timer
export const HEADER_TIMER = "688c3aff68e6df381a437a08"
export const TIMER_TASK = "688c3b6968e6df381a437a12"

export const HOLIDAYS = "68c13da06894391e39d13d6c"
export const HOLIDAYS_TYPE = "68c13dba6894391e39d13d70"
//employees work history
export const TECHNOLOGIES = "68d0d577219e91d73f24b271"
export const SALES_CHANNEL = "68d0d5a3219e91d73f24e63a"
 